import {Carousel, Image} from 'react-bootstrap';
import React, {Component} from 'react';

class PlaceHolder extends Component {

    constructor(props) {
        super(props);
        this.state = {
            is_active : false,
            images_loaded: false
        }
    }

    MyLoader = () => (
        <div style={{backgroundColor:'#f1f2f3',width: this.props.width ? this.props.width : '100%', height: this.props.height ? this.props.height : '100%'}}>
            
        </div>
    )

    get_placeholders = () => {
        let inner_jsx = [];
        for (let i = 0; i < this.props.images.length; i++) {
            if(i==0 && this.state.is_active && this.props.images.length>1){
                continue
            }
            var aspect_ratio = (this.props.mockup.height / this.props.mockup.width);
            var reverse_aspect_ratio = (this.props.mockup.width / this.props.mockup.height);
            //loader width
            var width = this.props.height ? ('calc(' + this.props.height + 'px * ' + reverse_aspect_ratio + ')') : '100%';
            var height = this.props.width ? ('calc(' + this.props.width + 'px * ' + aspect_ratio + ')') : '100%';
            inner_jsx.push(
                <Carousel.Item>
                    <div id="result_loader" className="loader" style={this.props.mockup.show_loader_gif?{display:'block'}:{display:'none'}}></div>
                    <div id="result_overlay" className="loader_overlay" style={this.props.mockup.show_loader_gif?{display:'block'}:{display:'none'}}> </div>
                    <div style={{display: (this.state.images_loaded) ? 'none' : 'block', width, height}}><this.MyLoader /></div>
                    <Image onLoad={() => this.setState({images_loaded: true})} style={{display: this.state.images_loaded ? 'block' : 'none', height: this.props.height ? this.props.height : 'auto', width: this.props.width ? this.props.width : 'auto', ...this.props.extra_styles}} id={this.props.mockup._id+"_"+i} className="mockup_image" src={this.props.images[i]} rounded/>
                </Carousel.Item>
            ); 
        }
        return inner_jsx;
    }

    handleMouseEnter = () => {
        this.setState({
            is_active : true
        })
    }

    handleMouseLeave = () => {
        this.setState({
            is_active : false
        })
    }

    render() {
        return (
            <Carousel controls={false} indicators={false} pauseOnHover={false} interval={1} slide={this.state.is_active} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
                {this.get_placeholders()}
            </Carousel>
        );
    }   
} 

export default PlaceHolder;